import { Component, OnInit } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import {
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router
} from '@angular/router';
import { LoaderType } from '@nibras/shared/components';
import { DAILY_DATE_FORMATS } from '@nibras/shared/date-formats';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: DAILY_DATE_FORMATS }
  ]
})
export class AppComponent implements OnInit {
  title = 'Nibras';
  loading = true;
  loaderType: typeof LoaderType = LoaderType;

  constructor(
    private _iconRegistry: MatIconRegistry,
    private _domSanitizer: DomSanitizer,
    router: Router
  ) {
    router.events.subscribe((routerEvent: Event) => {
      this.checkRouterEvent(routerEvent);
    });

    this._iconRegistry.addSvgIconInNamespace(
      'assets',
      'appcenter',
      this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/appcenter.svg')
    );
    this._iconRegistry.addSvgIcon(
      'datamapping',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/datamapping.svg')
    );
    this._iconRegistry.addSvgIcon(
      'starttask',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/starttask.svg')
    );
    this._iconRegistry.addSvgIcon(
      'analytics',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/analytics.svg')
    );
    this._iconRegistry.addSvgIcon(
      'excelexport',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/excelexport.svg')
    );
    this._iconRegistry.addSvgIcon(
      'csv-file-format',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/csv-file-format.svg')
    );
    this._iconRegistry.addSvgIcon(
      'checkedGreenStatus',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/checkedGreenStatus.svg')
    );
    this._iconRegistry.addSvgIcon(
      'minuStatusReds',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/minuStatusReds.svg')
    );
    this._iconRegistry.addSvgIcon(
      'completed_task',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/completed_task.svg')
    );
    this._iconRegistry.addSvgIcon(
      'pending_task',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/pending_task.svg')
    );
    this._iconRegistry.addSvgIcon(
      'expired_task',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/expired_task.svg')
    );
    this._iconRegistry.addSvgIcon(
      'planned_task',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/planned_task.svg')
    );
    this._iconRegistry.addSvgIcon(
      'tree_expand',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/tree_expand.svg')
    );
    this._iconRegistry.addSvgIcon(
      'tree_colapse',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/tree_colapse.svg')
    );
    this._iconRegistry.addSvgIcon(
      'tree_leaf_node',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/tree_leaf_node.svg')
    );
    this._iconRegistry.addSvgIcon(
      'cancel',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/cancel.svg')
    );
    this._iconRegistry.addSvgIcon(
      'close_small',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/close_small.svg')
    );
    this._iconRegistry.addSvgIcon(
      'graph',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/graph.svg')
    );
    this._iconRegistry.addSvgIcon(
      'list',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/list.svg')
    );
    this._iconRegistry.addSvgIcon(
      'logout',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/logout.svg')
    );
    this._iconRegistry.addSvgIcon(
      'plug',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/plug.svg')
    );
    this._iconRegistry.addSvgIcon(
      'zoom_plus',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/chart/zoom_plus.svg')
    );
    this._iconRegistry.addSvgIcon(
      'zoom_back',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/chart/zoom_back.svg')
    );
    this._iconRegistry.addSvgIcon(
      'img_download',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/chart/img_download.svg')
    );
    this._iconRegistry.addSvgIcon(
      'settings',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/chart/settings.svg')
    );
    this._iconRegistry.addSvgIcon(
      'state_sla',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/state_sla.svg')
    );
    this._iconRegistry.addSvgIcon(
      'state_triggered',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/state_triggered.svg')
    );
    this._iconRegistry.addSvgIcon(
      'state_cleared',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/state_cleared.svg')
    );
    this._iconRegistry.addSvgIcon(
      'status_completed',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/status_completed.svg')
    );
    this._iconRegistry.addSvgIcon(
      'status_expired',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/status_expired.svg')
    );
    this._iconRegistry.addSvgIcon(
      'status_planned',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/status_planned.svg')
    );
    this._iconRegistry.addSvgIcon(
      'status_pending',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/state_cleared.svg')
    );
    this._iconRegistry.addSvgIcon(
      'clear_all_svg',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/clear_outline.svg')
    );
    this._iconRegistry.addSvgIcon(
      'incoming',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/incoming.svg')
    );
    this._iconRegistry.addSvgIcon(
      'outgoing',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/outgoing.svg')
    );
    this._iconRegistry.addSvgIcon(
      'view_info',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/view_info.svg')
    );
    this._iconRegistry.addSvgIcon(
      'side_bar',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/side_bar.svg')
    );
    this._iconRegistry.addSvgIcon(
      'deviated',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/deviated.svg')
    );
    this._iconRegistry.addSvgIcon(
      'vertical',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/vertical.svg')
    );
    this._iconRegistry.addSvgIcon(
      'add_track',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/add_track.svg')
    );
    this._iconRegistry.addSvgIcon(
      'add_comment',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/add_comment.svg')
    );
    this._iconRegistry.addSvgIcon(
      'remove_comment',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/remove_comment.svg')
    );
    this._iconRegistry.addSvgIcon(
      'save_comment',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/save_comment.svg')
    );
    this._iconRegistry.addSvgIcon(
      'distance_measurement',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/distance-measurement.svg')
    );
    this._iconRegistry.addSvgIcon(
      'text_size_increment',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/text_size_increment.svg')
    );
    this._iconRegistry.addSvgIcon(
      'text_size_decrement',
      this._domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/text_size_decrement.svg')
    );
  }

  ngOnInit() {
    // Start the connection up!
    //
    //console.log('Starting the channel service');
    //this.channelService.start();
  }

  checkRouterEvent(routerEvent: Event): void {
    if (routerEvent instanceof NavigationStart) {
      this.loading = true;
    } else if (
      routerEvent instanceof NavigationEnd ||
      routerEvent instanceof NavigationCancel ||
      routerEvent instanceof NavigationError
    ) {
      this.loading = false;
    }
  }
}
